"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowButton = void 0;
var react_1 = __importStar(require("react"));
var button_style_1 = __importDefault(require("./button.style"));
var LogoLeft_1 = __importDefault(require("./LogoLeft"));
var LogoRight_1 = __importDefault(require("./LogoRight"));
var Loading_1 = require("./Loading");
var network_1 = require("@cyberlab/cyberconnect/lib/network");
var queries_1 = require("./../utils/queries");
var cyberconnect_1 = __importStar(require("@cyberlab/cyberconnect"));
var useIsMountedRef_1 = require("./../hooks/useIsMountedRef");
var FollowButton = function (_a) {
    var provider = _a.provider, namespace = _a.namespace, _b = _a.env, env = _b === void 0 ? cyberconnect_1.Env.PRODUCTION : _b, _c = _a.chain, chain = _c === void 0 ? cyberconnect_1.Blockchain.ETH : _c, chainRef = _a.chainRef, _d = _a.toAddr, toAddr = _d === void 0 ? "" : _d, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    var _e = (0, react_1.useState)(false), following = _e[0], setFollowing = _e[1];
    var _f = (0, react_1.useState)("Follow"), buttonText = _f[0], setButtonText = _f[1];
    var _g = (0, react_1.useState)(false), loading = _g[0], setLoading = _g[1];
    var wrapperRef = (0, react_1.useRef)(null);
    var _h = (0, react_1.useState)(false), showButton = _h[0], setShowButton = _h[1];
    var _j = (0, react_1.useState)(""), fromAddr = _j[0], setFromAddr = _j[1];
    var classes = (0, button_style_1.default)();
    //Only update state when the button is mounted. See: https://www.debuggr.io/react-update-unmounted-component/
    var isMountedRef = (0, useIsMountedRef_1.useIsMountedRef)();
    var apiURL = (0, react_1.useMemo)(function () {
        return network_1.endpoints[env].cyberConnectApi;
    }, [env]);
    var handleButtonMouseEnter = (0, react_1.useCallback)(function () {
        if (following) {
            setButtonText("Unfollow");
        }
        else {
            if (wrapperRef.current) {
                wrapperRef.current.classList.add("logoRotate");
            }
        }
    }, [following, wrapperRef]);
    var handleButtonMouseLeave = (0, react_1.useCallback)(function () {
        if (following) {
            setButtonText("Following");
        }
        if (wrapperRef.current) {
            wrapperRef.current.classList.remove("logoRotate");
        }
    }, [following, wrapperRef]);
    var updateElementStatus = (0, react_1.useCallback)(function (following) {
        setFollowing(following);
        if (following) {
            setButtonText("Following");
            if (wrapperRef.current) {
                wrapperRef.current.classList.remove("logoRotate");
            }
        }
        else {
            setButtonText("Follow");
        }
    }, [wrapperRef]);
    var follow = (0, react_1.useCallback)(function (toAddr) { return __awaiter(void 0, void 0, void 0, function () {
        var connectInstance, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectInstance = exports.FollowButton.cyberConnect;
                    if (!connectInstance) {
                        throw {
                            code: "FollowError",
                            message: "Can not find the connect instance",
                        };
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, connectInstance.connect(toAddr)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    throw {
                        code: "FollowError",
                        message: e_1.message || e_1,
                    };
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var unfollow = (0, react_1.useCallback)(function (toAddr) { return __awaiter(void 0, void 0, void 0, function () {
        var connectInstance, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectInstance = exports.FollowButton.cyberConnect;
                    if (!connectInstance) {
                        throw {
                            code: "UnfollowError",
                            message: "Can not find the connect instance",
                        };
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, connectInstance.disconnect(toAddr)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    throw {
                        code: "UnfollowError",
                        message: e_2.message || e_2,
                    };
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var handleButtonClick = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!exports.FollowButton.cyberConnect) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    if (!following) return [3 /*break*/, 3];
                    return [4 /*yield*/, unfollow(toAddr)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, follow(toAddr)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    updateElementStatus(!following);
                    if (onSuccess) {
                        onSuccess({
                            code: following ? "UnfollowSuccess" : "FollowSuccess",
                            toAddr: toAddr,
                        });
                    }
                    return [3 /*break*/, 8];
                case 6:
                    e_3 = _a.sent();
                    if (onFailure) {
                        onFailure(e_3);
                    }
                    console.error(e_3);
                    return [3 /*break*/, 8];
                case 7:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [
        toAddr,
        following,
        updateElementStatus,
        follow,
        unfollow,
        onSuccess,
        onFailure,
    ]);
    var getFollowStatus = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (showButton) {
                        return [2 /*return*/];
                    }
                    if (!fromAddr || !toAddr || !namespace) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, queries_1.followStatus)({
                            fromAddr: fromAddr,
                            toAddr: toAddr,
                            namespace: namespace,
                            url: apiURL,
                        })];
                case 1:
                    result = _c.sent();
                    if (!isMountedRef)
                        return [2 /*return*/];
                    if ((_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.followStatus) === null || _b === void 0 ? void 0 : _b.isFollowing) {
                        setFollowing(true);
                        setButtonText("Following");
                    }
                    if (!showButton) {
                        setShowButton(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [fromAddr, toAddr, namespace, apiURL, showButton]);
    var initCyberConnect = (0, react_1.useCallback)(function () {
        if (exports.FollowButton.cyberConnect) {
            return;
        }
        if (!namespace) {
            console.error("Namespace can not be empty");
            throw {
                code: "EmptyNamespace",
                message: "Namespace can not be empty",
            };
        }
        // @ts-ignore
        exports.FollowButton.cyberConnect = new cyberconnect_1.default({
            provider: provider,
            namespace: namespace,
            chain: chain,
            chainRef: chainRef,
            env: env,
        });
    }, [namespace, provider, env]);
    var getUserAddress = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var address;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, cyberconnect_1.getAddressByProvider)(provider, chain)];
                case 1:
                    address = _a.sent();
                    if (isMountedRef) {
                        if (address) {
                            setFromAddr(address);
                        }
                        else {
                            throw {
                                code: "NoETHAccount",
                                message: "Can not find the wallet address by the given provider",
                            };
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [provider, chain]);
    (0, react_1.useEffect)(function () {
        try {
            initCyberConnect();
        }
        catch (e) {
            console.error(e);
            if (onFailure) {
                onFailure(e);
            }
        }
    }, [initCyberConnect, onFailure]);
    (0, react_1.useEffect)(function () {
        getUserAddress();
    }, [getUserAddress]);
    (0, react_1.useEffect)(function () {
        getFollowStatus();
    }, [fromAddr]);
    if (!showButton) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classes.cyberConnectFollowButtonWrapper, onMouseEnter: handleButtonMouseEnter, onMouseLeave: handleButtonMouseLeave, ref: wrapperRef }, loading ? (react_1.default.createElement(Loading_1.LoadingIcon, null)) : (react_1.default.createElement("div", { className: classes.cyberConnectFollowButton, onClick: handleButtonClick },
        react_1.default.createElement("div", { className: classes.cyberConnectLogo },
            react_1.default.createElement(LogoLeft_1.default, { className: "".concat(classes.connectLogoPart, " ").concat(classes.connectLogoPartLeft) }),
            react_1.default.createElement(LogoRight_1.default, { className: "".concat(classes.connectLogoPart, " ").concat(classes.connectLogoPartRight) })),
        react_1.default.createElement("div", { className: classes.buttonText }, buttonText)))));
};
exports.FollowButton = FollowButton;
exports.FollowButton.cyberConnect = null;
//# sourceMappingURL=Button.js.map